import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
   faAngleDoubleLeft,
   faAngleDoubleRight,
   faCheckCircle,
   faColumns,
   faFileCsv,
   faFileEdit,
   faFilter,
   faPlusCircle,
   faTimesCircle,
   faTrashAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import {
   faAngleLeft,
   faAngleRight,
   faAngleUp,
   faChevronRight,
   faMinus,
   faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { Layout } from './constant';

export const tableIcons = {
   Add: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faPlusCircle} />
   )),
   Check: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faCheckCircle} />
   )),
   Clear: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faTimesCircle} />
   )),
   Delete: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faTrashAlt} size='xs' />
   )),
   // DetailPanel: React.forwardRef((props, ref) => (
   //   <FontAwesomeIcon ref={ref} {...props} icon={faChevronRight} size="xs" />
   // )),
   Edit: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faFileEdit} size='xs' />
   )),
   Export: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faFileCsv} />
   )),
   Filter: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faFilter} />
   )),
   FirstPage: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faAngleDoubleLeft} />
   )),
   LastPage: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faAngleDoubleRight} />
   )),
   NextPage: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faAngleRight} />
   )),
   PreviousPage: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faAngleLeft} />
   )),
   ResetSearch: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faTimesCircle} />
   )),
   Search: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faSearch} />
   )),
   SortArrow: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faAngleUp} />
   )),
   ThirdStateCheck: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faMinus} />
   )),
   ViewColumn: React.forwardRef((props, ref) => (
      <FontAwesomeIcon ref={ref} {...props} icon={faColumns} />
   )),
};

export const tableStyle = {
   borderRadius: '10px',
   border: `2px solid ${Layout.primary}`,
};

export const headerStyle = {
   backgroundColor: Layout.primary,
   fontFamily: 'DBHeaventBd', // old GSB
   fontSize: '1.4rem',
   color: '#fff',
};
